module.exports = __webpack_public_path__ + "img/nave-04.113d5a45.jpg";